/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_Api_V3_KeyInputs */

const en_admin_settings_fields_wechat_api_v3_key = /** @type {(inputs: Admin_Settings_Fields_Wechat_Api_V3_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIv3 Key`)
};

/**
* | output |
* | --- |
* | "APIv3 Key" |
*
* @param {Admin_Settings_Fields_Wechat_Api_V3_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_api_v3_key = /** @type {((inputs?: Admin_Settings_Fields_Wechat_Api_V3_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_Api_V3_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_wechat_api_v3_key(inputs)
});
export { admin_settings_fields_wechat_api_v3_key as "admin.settings.fields.wechat_api_v3_key" }